export const FORMULA_CATEGORIES = ["bars", "truffles", "pralines", "bonbons", "barks", "spreads", "hot_chocolate"];
export const FORMULA_STATUSES = ["prototype", "approved", "retired"];
export const EXPERIMENT_STATUSES = ["planned", "in_progress", "completed", "cancelled"];
export const LOCATION_TYPES = ["lab", "experience_centre", "cafe"];
export const CHANNELS = ["retail_store", "cafe", "experience_centre", "online"];
export const DOC_CATEGORIES = ["SOP", "technical_sheet", "regulatory_checklist", "playbook"];
export const FEEDBACK_SOURCES = ["experience_centre", "cafe", "workshop"];
export const FEEDBACK_TYPES = ["rating", "comment", "suggestion"];
export const PANEL_TYPES = ["trained_panel", "consumer"];
export const ASSIGNABLE_ROLES = ["rnd_scientist", "chef", "quality", "experience_centre_manager", "leadership"];
export const ALL_ROLES = [...ASSIGNABLE_ROLES, "admin"];
export const AI_TONES = ["concise", "detailed"];

export const INGREDIENT_TYPES = [
  "cocoa_mass", "cocoa_butter", "dairy", "sweetener", "nut", "nut_paste",
  "flavor", "spice", "inclusion", "emulsifier",
];

export const ALLERGENS = ["milk", "soy", "tree_nuts", "peanuts", "gluten", "eggs", "sesame"];

export const STORAGE_CONDITIONS = [
  "22C / 55% RH",
  "25C / 60% RH",
  "28C / 70% RH (monsoon sim)",
  "35C / 75% RH (stress)",
];

export const DEFAULT_CHECKPOINTS = [7, 30, 60, 90];

export const ROLE_LABELS = {
  rnd_scientist: "R&D Scientist",
  chef: "Chef",
  quality: "Quality",
  experience_centre_manager: "Experience Centre Manager",
  leadership: "Leadership",
  admin: "Admin",
};

export const NUTRIENT_FIELDS = [
  ["energy_kcal", "Energy (kcal)", 900],
  ["protein_g", "Protein (g)", 100],
  ["carbohydrate_g", "Carbohydrate (g)", 100],
  ["total_sugars_g", "Total sugars (g)", 100],
  ["added_sugars_g", "Added sugars (g)", 100],
  ["total_fat_g", "Total fat (g)", 100],
  ["saturated_fat_g", "Saturated fat (g)", 100],
  ["trans_fat_g", "Trans fat (g)", 100],
  ["fibre_g", "Dietary fibre (g)", 100],
  ["sodium_mg", "Sodium (mg)", 100000],
];

export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const UPLOAD_CHUNK_BYTES = 4 * 1024 * 1024;
export const ALLOWED_UPLOAD_EXTENSIONS = [
  "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "csv", "txt", "png", "jpg", "jpeg", "webp", "gif",
];

export const formatBytes = (bytes) => {
  if (!bytes) return "—";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
};

export const PAGE_SIZE = 50;

export const label = (v) => (v || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(n ?? 0);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
